import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

export default new Vuex.Store({
  state: {
    // userToken: window.localStorage.getItem('userToken') || null,
    userToken: window.sessionStorage.getItem('userToken') || null,
    userLoading: false,

    userData: null,
    routeJur: null,

    axiosSwitch: false
  },
  mutations: {
    setUserToken(state, token) {
      return new Promise((resolve, reject) => {
        if (token != '') {
          state.userToken = token
          resolve('success')
        } else {
          reject('is null')
        }
      })
    },
    fetchUserData(state) {
      if (!state.userToken) {
        return
      }
      state.userLoading = true

      axios
        .get(`web/getUserInfo?token=` + state.userToken)
        .then(({ data }) => {
          // console.log(data)
          if (data.RetCode) {
            state.userData = data.RetData
            state.routeJur = data.RetData.routeJur

            axios.defaults.headers.post['token'] = state.userToken
            axios.defaults.headers.get['token'] = state.userToken
            Vue.use(VueAxios, axios)

            state.axiosSwitch = true
          } else {
            window.sessionStorage.clear()
            state.userToken = null
            state.userData = null
            state.routeJur = null
            state.axiosSwitch = false
          }
          state.userLoading = false
        }).catch(() => {
          window.sessionStorage.clear()
          state.userToken = null
          state.userData = null
          state.routeJur = null
          state.axiosSwitch = false
        })
    },
    logout(state) {
      return new Promise((resolve, reject) => {
        // window.localStorage.clear()
        window.sessionStorage.clear()
        state.userToken = null
        state.userData = null
        state.routeJur = null
        state.axiosSwitch = false

        resolve('logout')
      })
    }
  },
  actions: {
    setUserToken({ commit }, value) {
      commit('setUserToken', value)
    },
    fetchUserData({ commit }) {
      commit('fetchUserData')
    },
    logout({ commit }) {
      commit('logout')
    }
  },
  getters: {

  }
})
